var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 93.57 93.571",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_15_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.566,12.176c0-5.799-12.886-10.496-28.781-10.496c-15.896,0-28.781,4.697-28.781,10.496v8.611 c0,5.797,12.885,10.494,28.781,10.494c1.086,0,2.156-0.023,3.211-0.067c0.559-7.487,12.34-11.897,25.57-12.98V12.176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,26.582l0.004,0.777v13.446c0,5.798,12.885,10.495,28.781,10.495c1.074,0,2.135-0.022,3.18-0.065V36.233 c-1.045,0.042-2.105,0.066-3.18,0.066C13.607,36.3,1.094,32.014,0,26.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.01,46.842L0.004,47.62v13.447c0,5.795,12.885,10.492,28.781,10.492c1.074,0,2.135-0.023,3.18-0.064V60.397v-3.904 c-1.045,0.045-2.105,0.066-3.18,0.066C13.607,56.559,1.103,52.273,0.01,46.842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.789,22.011c-15.895,0-28.783,4.697-28.783,10.493v8.612c0,5.798,12.888,10.494,28.783,10.494 S93.57,46.915,93.57,41.116v-8.612C93.57,26.708,80.684,22.011,64.789,22.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.789,56.629c-15.176,0-27.68-4.284-28.773-9.719l-0.01,0.777v13.444c0,5.799,12.888,10.495,28.783,10.495 S93.57,66.931,93.57,61.132V47.688c0-0.263-0.055-0.518-0.107-0.777C92.367,52.345,79.965,56.629,64.789,56.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.789,76.889c-15.176,0-27.67-4.286-28.764-9.716l-0.02,0.774v13.446c0,5.8,12.889,10.496,28.783,10.496 s28.781-4.696,28.781-10.496V67.948c0-0.261-0.056-0.521-0.107-0.774C92.367,72.602,79.965,76.889,64.789,76.889z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabases);
export default __webpack_public_path__ + "static/media/databases.18a452801f56a0ae8547345cca572dae.svg";
export { ForwardRef as ReactComponent };